import { render, staticRenderFns } from "./CardCountriesList.vue?vue&type=template&id=16b4376e&scoped=true&"
import script from "./CardCountriesList.vue?vue&type=script&lang=js&"
export * from "./CardCountriesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b4376e",
  null
  
)

export default component.exports